import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"send, email, paper-plane, arrow"} maskId="square-filled-radius-0-stroke-1-IconSend"><path d="M13.9934 22.987L21.3308 2.66791L1.01172 10.0054L10.6069 13.3919L13.9934 22.987Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSend;
